import React from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import CustomButton from '../../common/CustomButton';
import { Constants } from '../../../helpers/Constants';
import strings from '../../../localization';

import styles from './styles';

const PromptPlanRibbon = () => {
  const navigate = useNavigate();

  const goToBilling = () => {
    navigate(Constants.paths.pharmacyBilling);
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.label}>
        {strings.pleaseSelectAndAddCardDetails}
      </Typography>
      <CustomButton label={strings.addCard} onClick={goToBilling} />
    </Box>
  );
};

export default PromptPlanRibbon;
